/**
 * Label for the scheduled debit date on a subscription.
 * Until the first MP charge clears, show "Primeira cobrança"; afterwards "Próxima cobrança".
 *
 * @param {{ first_charge_pending?: boolean } | null | undefined} subscriptionOrResult
 * @param {{ isCreateResult?: boolean }} [options]
 */
export function subscriptionChargeLabel(subscriptionOrResult, options = {}) {
  if (options.isCreateResult) {
    return 'Primeira cobrança';
  }
  if (subscriptionOrResult?.first_charge_pending) {
    return 'Primeira cobrança';
  }
  return 'Próxima cobrança';
}
